module.exports = __webpack_public_path__ + "static/media/taxadvisory.3cff8f7c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/taxadvisory.svg
// module id = 155
// module chunks = 0